'use client';

import { LoadingDark, Typography } from '@musinsa/mds';
import { useQuery } from '@tanstack/react-query';
import { type FC, useState } from 'react';
import { curatorQueries } from '../query-factory';
import { EventListSection } from './EventListSection';
import { EventNoticeSheet } from './EventNoticeSheet';

export const CuratorEventsPage: FC = () => {
  const [noticeOpen, setNoticeOpen] = useState(false);
  const { data, isPending, isError } = useQuery(curatorQueries.mypage.events());

  if (isPending) {
    return (
      <div className="flex w-full justify-center items-center py-12! grow">
        <LoadingDark size="size24x24" />
      </div>
    );
  }

  if (isError || !data) {
    return null;
  }

  return (
    <div className="flex flex-col w-full grow pb-[72px]!">
      <div className="flex items-end justify-between mx-4 mt-6 mb-4">
        <Typography variant="title18pxMed">
          이벤트 상품을 활용해
          <br />
          수익을 높여보세요
        </Typography>
        <button type="button" onClick={() => setNoticeOpen(true)}>
          <Typography variant="body13pxReg" className="text-base-gray-9 underline">
            유의사항
          </Typography>
        </button>
      </div>
      <EventListSection events={data.events} />
      <EventNoticeSheet open={noticeOpen} onOpenChange={setNoticeOpen} />
    </div>
  );
};
